import { Box, Typography } from "@mui/material";

interface Props {
    amount: string,
    variant?: any,
    creditNote?: boolean
}

function AmountFormat({ amount, variant, creditNote }: Props) {

    return (
        <Typography
            // pr={2}
            display="flex"
            justifyContent="right"
            {...(variant ? { variant } : {})}

        >
            <Box textAlign="right" minWidth={80} fontWeight={creditNote ? 'bold' : '500'} color={creditNote ? '#E11D48' : 'inherit'}>
                {creditNote && "-"}{amount}
            </Box>
        </Typography>
    )

};

export default AmountFormat;